import { FormattedMessage } from "react-intl";
import React from "react";
import { Box, styled } from "@mui/material";
import { useSidebarStore } from "../../../store/sidebarStore";

// Custom styled components using MUI
const ProfilePictureTextWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100px",
  margin: "0 20px 0 20px",
  [`@media only screen and (max-width: ${theme.firstBreakpoint}px)`]: {
    margin: 0,
    alignItems: "center",
  },
}));

const StyledProfilePicture = styled(Box)(({ theme }) => ({
  cursor: "pointer",
  width: "40px",
  height: "40px",
  marginTop: "20px",
  borderRadius: "100%",
  [`@media only screen and (max-width: ${theme.firstBreakpoint}px)`]: {
    marginTop: "10px",
  },
}));

const Username = styled(Box)(({ theme, isOnVacation }) => ({
  fontSize: "16px",
  fontWeight: 500,
  textAlign: "center",
  lineHeight: "17px",
  color: isOnVacation ? "#F19191" : theme.mainTextColor,
  cursor: "pointer",
  marginTop: "10px",
}));

const UsernameWrapper = styled(Box)(({ theme }) => ({
  width: "150px",
  [`@media only screen and (max-width: ${theme.firstBreakpoint}px)`]: {
    display: "none",
  },
}));

export const ProfileButton = ({ getUserData, isProfileMenuOpen }) => {
  const { setLoggedInSidebarOpen } = useSidebarStore();

  return (
    <ProfilePictureTextWrapper>
      <StyledProfilePicture
        component="img"
        src={getUserData.user.profilePicture || undefined}
        onClick={() => {
          setLoggedInSidebarOpen(true);
        }}
        data-testid="logged-in-sidebar-button-icon"
      />
      <UsernameWrapper>
        <Username isOnVacation={getUserData.user.onHoliday}>
          {getUserData.user.onHoliday ? (
            <FormattedMessage id={"your-tutoring.vacation-mode-chat.profile"} />
          ) : (
            getUserData.user.username
          )}
        </Username>
      </UsernameWrapper>
    </ProfilePictureTextWrapper>
  );
};
